import { createContext, useContext, useEffect, useState, useCallback } from "react";

const QuoteCtx = createContext(null);
const KEY = "kosan_quote_cart";
const keyOf = (it) => `${it.category || ""}:${it.code || it.name}`;

export const QuoteProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = useCallback((it) => {
    setItems((prev) =>
      prev.some((p) => keyOf(p) === keyOf(it))
        ? prev
        : [...prev, { name: it.name, category: it.category || "", code: it.code || "", image: it.image || "" }]
    );
  }, []);

  const remove = useCallback((it) => {
    setItems((prev) => prev.filter((p) => keyOf(p) !== keyOf(it)));
  }, []);

  const clear = useCallback(() => setItems([]), []);
  const has = useCallback((it) => items.some((p) => keyOf(p) === keyOf(it)), [items]);
  const toggle = useCallback(
    (it) => setItems((prev) => (prev.some((p) => keyOf(p) === keyOf(it)) ? prev.filter((p) => keyOf(p) !== keyOf(it)) : [...prev, { name: it.name, category: it.category || "", code: it.code || "", image: it.image || "" }])),
    []
  );

  return (
    <QuoteCtx.Provider value={{ items, add, remove, clear, has, toggle, open, setOpen, count: items.length }}>
      {children}
    </QuoteCtx.Provider>
  );
};

export const useQuote = () => useContext(QuoteCtx);
